import React from "react";
import { useDispatch , useSelector } from "react-redux";


import { modifyDisplaymodal , definetypetablo } from "../../state/redux";
import { useCourtier } from "../../state/reactquery";



import EcranGestionFiltersSearch from "./EcranGestionFiltersSearch";
import EcranGestionFilterLeads from "./EcranGestionFilterLeads";
import EcranGestionListe from "./EcranGestionListe";
import EcranGestionContrats from "./EcranGestionContrats";
import EcranGestionCommissions from "./EcranGestionCommissions";

import './EcranGestion.scss';
const classNames = require('classnames');
function EcranGestion(){
        const dispatch = useDispatch() ;
        const {data:courtier}  = useCourtier() ; 

        const onglet_commisssions =  courtier?.nomdomaine==='fidelis' ||  courtier?.nomdomaine==='cabinettest' ; 
        const typetablo = useSelector(state=>state.gestion.typetablo);
    
        const clickchoiceonglet = (e)=>{ dispatch(definetypetablo(e.target.id)); }

        const displaymodalrecherche = ()=>{
            typetablo==='contrats'? dispatch(modifyDisplaymodal('mod_searchcontrats')): dispatch(modifyDisplaymodal('mod_searchgestion'))  ;
        }

    return(<div className="ecran_gestion">
                <div className="ecrangestiontop">
                                <div className="ecrangestiontop_left"  >{courtier?.nomcommercial}  </div>
                                <input  className="dashbordtop_input" placeholder='Recherche' type="text"  onFocus={displaymodalrecherche}     />
                            </div>
                            <div className="onglets"> 
                                        <div id='gestion' className={classNames({'selected':typetablo==='gestion'})} onClick={clickchoiceonglet} >Leads</div> 
                                        <div id='analytique' className={classNames({'selected':typetablo==='analytique'})} onClick={clickchoiceonglet} >Analytique</div> 
                                        <div id='contrats' className={classNames({'selected':typetablo==='contrats'})} onClick={clickchoiceonglet} >Contrats</div>  
                                       { onglet_commisssions && <div id='commissions' className={classNames({'selected':typetablo==='commissions'})} onClick={clickchoiceonglet} >Commissions</div>  }
                             </div>
                 {typetablo ==='commissions'?<EcranGestionCommissions   />:
                  typetablo ==='contrats'?<EcranGestionContrats   />:<><EcranGestionFiltersSearch  />
                                                                        <EcranGestionFilterLeads  />
                                                                        <EcranGestionListe  /></>}
             </div>)
}

export default EcranGestion ; 


